export type BoggleChallengeScoreThresholds = {
  aceScore: number
  targetScore: number
}

export type BoggleChallengeScoreRank = 'ace' | 'below-target' | 'target'

function getResolvedBoggleChallengeScore(score: number) {
  if (!Number.isFinite(score)) {
    return 0
  }

  return Math.max(0, Math.round(score))
}

export function getBoggleChallengeScoreRank(
  score: number,
  thresholds: BoggleChallengeScoreThresholds,
): BoggleChallengeScoreRank {
  const resolvedScore = getResolvedBoggleChallengeScore(score)

  if (resolvedScore >= thresholds.aceScore) {
    return 'ace'
  }

  if (resolvedScore >= thresholds.targetScore) {
    return 'target'
  }

  return 'below-target'
}
